import React from "react";

const OrderedListIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.16669 4.16797L4.16669 3.16797V6.83464M4.16669 6.83464H3.16669M4.16669 6.83464H4.83335M8.83334 9.5013H7.77084C7.28368 9.5013 7.01216 8.95856 7.27054 8.57288C7.30238 8.52536 7.34744 8.48872 7.39505 8.45703L8.59496 7.6586C8.64257 7.62692 8.68748 7.59012 8.71999 7.54306C9.01691 7.11319 8.71421 6.5013 8.16841 6.5013H7.16669M11.1667 9.83464H12.1309C12.9539 9.83464 13.0999 11.093 12.3401 11.3051C12.3033 11.3153 12.2647 11.3194 12.2265 11.3208L11.8334 11.3346L12.2265 11.3485C12.2647 11.3498 12.3033 11.3539 12.3401 11.3642C13.0999 11.5763 12.9539 12.8346 12.1309 12.8346H11.1667"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OrderedListIcon;
